import React, { useRef, useState, useEffect, useMemo } from "react";
import { useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import { Dialog } from "primereact/dialog";
import { Dropdown as PrimeDropdown } from "../../PrimeReactComponents";

import { Dropdown, Button } from "../../BootstrapComponents";
import {
  InputText,
  DataTable,
  Column,
  confirmDialog,
  Toast,
  confirmPopup,
} from "../../PrimeReactComponents";
import FilterOffset from "./components/OffsetRight";
import dataTableConfig from "../../config/dataTableOptions";
//import useDataTableFilter from '../../features/customUseHook/useDataTableFilter'
import { useResizeListener } from "primereact/hooks";
import Moment from "react-moment";
import Loader from "../../features/loader/Loader";
import { getAllCustomer, getAllDriver } from "../../services/commonController";
import {
  listData,
  deleteData,
  activeInactive,
  activeInactiveBulk,
  removeDataBulk,
  consignmentDriverUpdate,
  saveListView,
  getAllFieldListView,
} from "../controllers/ConsignmentController";
import { appAxios } from "../controllers/common/AxiosFile";
import { REACT_APP_API_URL, REACT_APP_TABLE_ROWS } from "../../config";

function List() {
  const { transportUserInfo } = useSelector((state) => state);
  const toast = useRef(null);
  const navigate = useNavigate();
  const reciveLocalData = transportUserInfo.company_id;
  const [tableHeight, setTableHeight] = React.useState("0px");
  const [list, setList] = useState([]);
  const [allCustomer, setAllCustomer] = useState();
  const [allDriver, setAllDriver] = useState();
  const [loader, setLoader] = useState(false);
  const [isListUpdated, setIsListUpdated] = useState(false);

  const [loading, setLoading] = useState(false);
  const [totalRecords, setTotalRecords] = useState(0);
  const [selectAll, setSelectAll] = useState(false);
  const [selectedCustomers, setSelectedCustomers] = useState(null);
  const [selectedRepresentative, setSelectedRepresentative] = useState(null);
  const [offsetFilter, setoffsetFilter] = useState(false);
  const [driverPopup, setDriverPopup] = useState(false);
  const [selectedDriver, setSelectedDriver] = useState(null);
  const [selectedConsignment, setSelectedConsignment] = useState(null);
  const [driverError, setDriverError] = useState("");
  const [visibleColumns, setVisibleColumns] = useState([]);
  const [consignmentViewPopup, setConsignmentViewPopup] = useState(false);
  const [listViewFields, setListViewFields] = useState([]);
  const [editViewFields, setEditViewFields] = useState([]);
  const [editingRow, setEditingRow] = useState(null);
  const [itemsPopup, setItemsPopup] = useState(false);
  const [selectedItems, setSelectedItems] = useState([]);
  const [globalFilterValue, setGlobalFilterValue] = useState("");
  const user_id = transportUserInfo.user_id;
  const [specialInstructionPopup, setSpecialInstructionPopup] = useState(false);
  const [selectedSpecialInstruction, setSelectedSpecialInstruction] = useState("");

  let consignmentListArr = [];
  let consignmentArr = [];
  let transportPermission = JSON.parse(
    localStorage.getItem("rolePermissionTransportInfo"),
  );

  transportPermission.length > 0 &&
    transportPermission
      .filter((e) => e.menuData?.menu_name === "Consignments")
      ?.map((val) => {
        if (!consignmentListArr.includes(val?.menuData?.menu_name)) {
          consignmentListArr.push(val?.menuData?.menu_name);
        }

        if (!consignmentArr.includes(val?.menuActionData?.action_name)) {
          consignmentArr.push(val?.menuActionData?.action_name);
        }
      });

  if (consignmentListArr.length === 0) {
    navigate("/transport/404");
  }

  const [bindWindowResizeListener, unbindWindowResizeListener] =
    useResizeListener({
      listener: (event) => {
        setTableHeight(
          document.querySelector(".table-wrapper").scrollHeight - 250 + "px",
        );
      },
    });

  useEffect(() => {
    bindWindowResizeListener();

    return () => {
      unbindWindowResizeListener();
    };
  }, [bindWindowResizeListener, unbindWindowResizeListener]);

  const [lazyParams, setLazyParams] = useState({
    first: 0,
    rows: REACT_APP_TABLE_ROWS ?? 50,
    page: 1,
    sortField: "",
    sortOrder: 1,
    status: "",
    company_id: reciveLocalData,
    globalFilterValue: "",
    job_number: "",
    pickup_date: "",
    delivery_date: "",
    filters: {
      job_number: { value: "", matchMode: "contains" },
      manifest_number: { value: "", matchMode: "contains" },
      customer_id: { value: "", matchMode: "contains" },
      customer_address: { value: "", matchMode: "contains" },
      delivery_address: { value: "", matchMode: "contains" },
      special_instruction:{ value: "",matchMode: "contains" },
      pallets: { value: "", matchMode: "contains" },
      spaces: { value: "", matchMode: "contains" },
      weight: { value: "", matchMode: "contains" },
      no_of_items: { value: "", matchMode: "contains" },
      pickup_date: { value: "", matchMode: "contains" },
      delivery_date: { value: "", matchMode: "contains" },
      driver_id: { value: "", matchMode: "contains" },
    },
  });
  useEffect(() => {
    if (user_id) {
      getlistViewData(user_id, 1, "list_view");
    }
  }, [user_id]);

  let loadLazyTimeout = null;

  useEffect(() => {
    loadLazyData();
  }, [lazyParams]);

  const loadLazyData = () => {
    setLoading(true);

    if (loadLazyTimeout) {
      clearTimeout(loadLazyTimeout);
    }

    //imitate delay of a backend call
    loadLazyTimeout = setTimeout(
      () => {
        listData({ lazyEvent: JSON.stringify(lazyParams) }).then((data) => {
          setTotalRecords(data?.data?.data?.count);
          setList(data?.data?.data?.rows);
          getAllCustomerData(lazyParams?.company_id);
          getAllDriverData(lazyParams?.company_id);
          setTableHeight(
            document.querySelector(".table-wrapper").scrollHeight - 100 + "px",
          );
          setLoading(false);
        });
      },
      Math.random() * 1000 + 250,
    );
  };

  const onPage = (event) => {
    const { page } = lazyParams;
    setLazyParams(
      {
        ...lazyParams,
        pageCount: event.pageCount,
        first: event.first,
        page: event.page === 0 ? 1 : event.page + 1,
        rows: REACT_APP_TABLE_ROWS ?? 50,
        multiSortMeta: event.multiSortMeta,
        filters: event.filters,
        globalFilterValue: "",
      },
      [],
    );
  };

  const onSort = (event) => {
    setLazyParams({
      ...lazyParams,
      sortField: event.sortField,
      sortOrder: event.sortOrder,
    });
  };

  const onFilter = (event) => {
    event["first"] = 0;
    setLazyParams(event);
  };

  const onSelectionChange = (event) => {
    const value = event.value;
    setSelectedCustomers(value);
    setSelectAll(value.length === totalRecords);
  };

  const onSelectAllChange = (event) => {
    const selectAll = event.checked;

    if (selectAll) {
      listData.then((data) => {
        setSelectAll(true);
        setSelectedCustomers(data.rows);
      });
    } else {
      setSelectAll(false);
      setSelectedCustomers([]);
    }
  };

  const advanceSearch = (value) => {
    if (value) {
      setLazyParams({
        ...lazyParams,
        globalFilterValue: value.job_number,
        job_number: value.job_number,
        pickup_date: value.pickup_date,
        delivery_date: value.delivery_date,
        status: value.status,
      });
      setoffsetFilter(true);
    } else {
      setoffsetFilter(false);
      setLazyParams({ ...lazyParams });
    }
  };
  const onGlobalFilterChange1 = (event) => {
    const value = event.target.value;
    setGlobalFilterValue(value);
    if (value.length > 2) {
      setLazyParams({ ...lazyParams, globalFilterValue: value });
    } else if (value.length === 0) {
      //   loadLazyData();
      setLazyParams({ ...lazyParams, globalFilterValue: "" });
    }    
  }; 

  const onGlobalFilterChangeOnclick = (event) => { 
    event.preventDefault();
    const value = globalFilterValue|| "";
      if (value.length >=1) {
        setLazyParams({ ...lazyParams, globalFilterValue: value });
      } 
  };

  const getAllCustomerData = async (company_id) => {
    const results = await getAllCustomer(company_id);
    setAllCustomer(results.data);
  };

  const getAllDriverData = async (company_id) => {
    const results = await getAllDriver(company_id);
    setAllDriver(results.data);
  };
  const getlistViewData = async (user_id, view_id, view_type) => {
    setLoader(true);
    const results = await getAllFieldListView(user_id, view_id, view_type);
    if (view_type == "list_view") {
      setListViewFields(results.data);
      setLoader(false);
    } else {
      setEditViewFields(results.data);
      setLoader(false);
    }
  };
  const handleCheckboxChange = (field) => {
    setEditViewFields((prev) =>
      prev.map((item) =>
        item.field === field ? { ...item, selected: !item.selected } : item,
      ),
    );
  };
  const actionBodyTemplate = (rowData) => {
    return (
      <>
        <div className="d-flex gap-2">
          <Link
            title="Edit Consignment"
            to={"edit/" + rowData?.consignment_id}
            className={`btn fz16 p-0 edit-btn ${consignmentArr.includes("Edit") ? "" : "border-0 shadow-none disabled"}`}
          >
            <i className="fa-light fa-edit"></i>
          </Link>
          <Button
            className={`deleteRow btn fz16 p-0 delete-btn ${consignmentArr.includes("Delete") ? "" : "border-0 shadow-none disabled"}`}
            variant=""
            title="Delete Consignment"
            onClick={() => deleteConfirm(rowData?.consignment_id)}
          >
            <i className="fa-light fa-trash"></i>
          </Button>
          <Link
            title="View Consignment"
            to={"view/" + rowData?.consignment_id}
            className={`btn p-0 fz16  ${consignmentArr.includes("View") ? "" : "border-0 shadow-none disabled"}`}
          >
            <i className="fa-light fa-eye"></i>
          </Link>
          {/* Update Driver Popup Icon 
          <Button className="btn p-0 fz16 text-dark" variant="" title="Update Driver" onClick={() => openDriverPopup(rowData)}>
            <i className="fa-light fa-truck"></i>
          </Button>*/}
        </div>
      </>
    );
  };

  const deleteConfirm = (data) => {
    confirmDialog({
      message: "Are you sure you want to delete?",
      header: "Confirmation",
      icon: "pi pi-exclamation-triangle",
      accept: () => {
        deleteData(data).then((res) => {
          toast?.current?.show({
            severity: "success",
            detail: "Deleted Successfully",
            life: 3000,
          });
          loadLazyData();
          setLoader(false);
          setTimeout(() => {
            navigate("/transport/consignments");
          }, 3000);
        });
      },
      reject: () => {
        console.log("Not delete");
      },
    });
  };

  const activeInactiveStatus = (status, id) => {
    setLoader(true);
    activeInactive(status, id).then(({ type, message }) => {
      setIsListUpdated(true);
      setLoader(false);
      loadLazyData();
      toast?.current?.show({
        severity: type,
        summary: "Info Message",
        detail: message,
        life: 3000,
      });
    });
  };
  const activeInactiveHandler = (event, data) => {
    setIsListUpdated(false);
    confirmPopup({
      target: event.currentTarget,
      message: `Are you sure you want to ${data.status === "1" ? "Inactivate" : "Activate"}?`,
      icon: "pi pi-exclamation-triangle",
      accept: () => {
        activeInactiveStatus(data.status, data.consignment_id);
      },
    });
  };

  const statusBodyTemplate = (rowData) => {
    /*  if (rowData.status == '0' || rowData.status == '1') {
       return <span onClick={(e) => activeInactiveHandler(e, rowData)} className={`fw600 border-0 badge py-2 badge-bg-${rowData.status === '1' ? "green" : "red"}`}>{rowData.status === '1' ? "Active" : "Inactive"}</span>; */

    if (rowData.status == "0") {
      return (
        <span className={`fw600 border-0 badge py-2 fs-5 badge-bg-yellow`}>
          Booked
        </span>
      );
    } else if (rowData.status == "1") {
      return (
        <span className={`fw600 border-0 badge py-2 fs-5 badge-bg-red`}>
          In transit
        </span>
      );
    } else {
      return (
        <span className={`fw600 border-0 badge py-2 fs-5 badge-bg-green`}>
          Delivered
        </span>
      );
    }
  };

  const createdDateTemplate = (rowData) => {
    return (
      <span>
        {rowData?.createdAt !== "" ? (
          <Moment date={rowData?.createdAt} format="D MMM YYYY" />
        ) : (
          ""
        )}
      </span>
    );
  };

  const createdByTemplate = (rowData) => {
    return (
      <span>
        {rowData?.userData?.first_name} {rowData?.userData?.last_name}{" "}
      </span>
    );
  };

  const pickupDateTemplate = (rowData) => {
    return (
      <span>
        {rowData?.pickup_date !== "" ? (
          <Moment date={rowData?.pickup_date} format="D MMM YYYY" />
        ) : (
          ""
        )}
      </span>
    );
  };

  const specialInstTemplate = (rowData) => {
  const instruction = rowData?.special_instruction || "";

  if (!instruction) {
    return <span>-</span>;
  }

  if (instruction.length <= 49) {
    return <span>{instruction}</span>;
  }

  return (
    <div>
      <span>
        {instruction.substring(0, 49)}
      </span>
      <Button
        variant=""
        className="btn btn-link p-0 ms-1 "
        onClick={() => {
          setSelectedSpecialInstruction(instruction);
          setSpecialInstructionPopup(true);
        }}
        title="View More"
      >
       <i className="fa-solid fa-ellipsis" style={{ color: "#13bf11" }}></i>
      </Button>
    </div>
  );
};
  const palletsTemplate = (rowData) => {
    return <span>{rowData?.consignment_details?.pallets}</span>;
  };

  const spacesTemplate = (rowData) => {
    return <span>{rowData?.consignment_details?.spaces}</span>;
  };

  const weightTemplate = (rowData) => {
    return <span>{rowData?.consignment_details?.weight}</span>;
  };

  const itemsTemplate = (rowData) => {
    const noOfItems = rowData?.consignment_details?.no_of_items || 0;

    return (
      <div className="d-flex align-items-center gap-2">
        <span>{noOfItems}</span>

        {noOfItems > 0 && (
          <Button
            variant=""
            className="btn p-0"
            title="View Items"
            onClick={() => {
              const noOfItems =
                rowData?.consignment_details?.no_of_items_single
                  ?.split("||")
                  .map((item) => item.trim()) || [];
              const freightDesc =
                rowData?.consignment_details?.freight_desc
                  ?.split("||")
                  .map((item) => item.trim()) || [];

              const pallets =
                rowData?.consignment_details?.pallets_single
                  ?.split("||")
                  .map((item) => item.trim()) || [];

              const spaces =
                rowData?.consignment_details?.spaces_single
                  ?.split("||")
                  .map((item) => item.trim()) || [];

              const weight =
                rowData?.consignment_details?.weight_single
                  ?.split("||")
                  .map((item) => item.trim()) || [];

              const jobTemp =
                rowData?.consignment_details?.job_temp
                  ?.split("||")
                  .map((item) => item.trim()) || [];
              
              const senders =
                rowData?.consignment_details?.senders_no
                  ?.split("||")
                  .map((item) => item.trim()) || [];   
              const recipients =
                rowData?.consignment_details?.recipient_no
                  ?.split("||")
                  .map((item) => item.trim()) || [];     

              const items = Array.from(
                {
                  length: Math.max(senders.length, recipients.length, jobTemp.length, freightDesc.length),
                },
                (_, index) => ({
                  no_of_items: noOfItems[index] || "-",
                  freight_desc: freightDesc[index] || "-",
                  pallets: pallets[index] || "-",
                  spaces: spaces[index] || "-",
                  weight: weight[index] || "-",                  
                  job_temp: jobTemp[index] || "-",
                  recipient_no: recipients[index] || "-",
                  senders_no: senders[index] || "-",
                  
                }),
              );

              setSelectedItems(items);
              setItemsPopup(true);
            }}
          >
            <i className="fa-light fa-box"></i>
          </Button>
        )}
      </div>
    );
  };

  const deliveryDateTemplate = (rowData) => {
    return (
      <span>
        {rowData?.delivery_date !== "" ? (
          <Moment date={rowData?.delivery_date} format="D MMM YYYY" />
        ) : (
          ""
        )}
      </span>
    );
  };

  const driverNameTemplate = (rowData) => {
    return (
      <span>
        {rowData?.driver?.first_name !== ""
          ? rowData?.driver?.first_name.concat(" ", rowData?.driver?.last_name)
          : ""}
      </span>
    );
  };

  const customerTemplate = (rowData) => {
    return (
      <span>
        {rowData?.customer_details?.customer_company_name !== ""
          ? rowData?.customer_details?.customer_company_name
          : ""}
      </span>
    );
  };

  const pickupCustomerTemplate = (rowData) => {
    let customerName =
      rowData?.customer_pickup_details?.customer_company_name !== undefined
        ? `${rowData?.customer_pickup_details?.customer_company_name}  ,  `
        : "";
    return (
      <span>
        {customerName} {rowData?.customer_pickup_details?.suburb}
      </span>
    );
  };

  const deliveryCustomerTemplate = (rowData) => {
    let customerName =
      rowData?.customer_delivery_details?.customer_company_name !== undefined
        ? `${rowData?.customer_delivery_details?.customer_company_name}  ,  `
        : "";
    return (
      <span>
        {customerName} {rowData?.customer_delivery_details?.suburb}
      </span>
    );
  };

  const manifestTemplate = (rowData) => {
    return (
      <span>
        {rowData?.manifest_number !== "Not Found"
          ? rowData?.manifest_number
          : ""}
      </span>
    );
  };

  // BULK CHANGES
  const activeInactiveStatusBulk = (status, id) => {
    setLoader(true);
    activeInactiveBulk(status, id, reciveLocalData).then(
      ({ type, message }) => {
        setIsListUpdated(true);
        setSelectedCustomers([]);
        loadLazyData();
        setLoader(false);
        toast?.current?.show({
          severity: type,
          summary: "Info Message",
          detail: message,
          life: 3000,
        });
      },
    );
  };

  const bulkActivate = () => {
    let selectedId = [];
    selectedCustomers &&
      selectedCustomers.length > 0 &&
      selectedCustomers.map((item, index) => {
        return selectedId.push(item.consignment_id);
      });
    setIsListUpdated(false);
    setSelectedCustomers();
    confirmPopup({
      message: `Are you sure you want to 'Activate'?`,
      icon: "pi pi-exclamation-triangle",
      accept: () => {
        activeInactiveStatusBulk("1", selectedId);
      },
    });
  };

  const bulkDeActivate = () => {
    let selectedId = [];
    selectedCustomers &&
      selectedCustomers.length > 0 &&
      selectedCustomers.map((item, index) => {
        return selectedId.push(item.consignment_id);
      });
    setIsListUpdated(false);
    setSelectedCustomers();
    confirmPopup({
      message: `Are you sure you want to 'Inactivate'?`,
      icon: "pi pi-exclamation-triangle",
      accept: () => {
        activeInactiveStatusBulk("0", selectedId);
      },
    });
    setSelectedCustomers();
  };

  const DeleteBulk = (id) => {
    setLoader(true);
    removeDataBulk(id, reciveLocalData).then(({ type, message }) => {
      setIsListUpdated(true);
      setSelectedCustomers([]);
      loadLazyData();
      setLoader(false);
      toast?.current?.show({
        severity: type,
        summary: "Info Message",
        detail: id.length > 0 ? message : "No consignment selected to delete",
        life: 3000,
      });
    });
  };
  const bulkDelete = () => {
    let selectedId = [];
    selectedCustomers &&
      selectedCustomers.length > 0 &&
      selectedCustomers.map((item, index) => {
        return selectedId.push(item.consignment_id);
      });
    setIsListUpdated(false);
    confirmPopup({
      message: `Are you sure you want to 'Delete'?`,
      icon: "pi pi-exclamation-triangle",
      accept: () => {
        DeleteBulk(selectedId);
      },
    });
  };
  const downloadConsignment = async (type) => {
    try {
      const {
        company_id,
        sortOrder,
        sortField,
        globalFilterValue,
        pickup_date,
        delivery_date,
        status,
      } = lazyParams;
      const response = await appAxios().get(
        `${REACT_APP_API_URL}consignments/downloadconsignments/${company_id}/transport?user_id=${user_id}&keyword=${globalFilterValue || ""}&pickup_date=${pickup_date || ""}&delivery_date=${delivery_date || ""}&status=${status || ""}&sortkey=${sortField || ""}&sortvalue=${sortOrder === 1 ? "desc" : "asc"}&filetype=${type}`,
        { responseType: "blob" },
      );

      const blob = new Blob([response.data]);
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = window.URL.createObjectURL(blob);
      link.download =
        type === "csv"
          ? `consignments_${Date.now()}.csv`
          : `consignments_${Date.now()}.xlsx`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    } catch (err) {
      if (err.response?.data instanceof Blob) {
        const errorText = await err.response.data.text();
        const errorJson = JSON.parse(errorText);

        toast.current.show({
          severity: "warn",
          summary: "Warning",
          detail: errorJson.message || "Download failed",
          life: 3000,
        });
      } else {
        toast.current.show({
          severity: "error",
          summary: "Error",
          detail: err.message,
          life: 3000,
        });
      }
    }
  };
  /*// const openDriverPopup = (rowData) => {
  //   setSelectedConsignment(rowData);
  //   setSelectedDriver(rowData?.driver_id || null);
  //   setDriverPopup(true);
  // };  
  const updateDriver = async () => {
    setLoader(true);
    if (!selectedDriver) {
      setLoader(false);
      setDriverError('Please select driver');
      return;
    }
    setDriverError('');
    let id = selectedConsignment?.consignment_id;
    const InputData = {
      driver_id: selectedDriver
    };

    consignmentDriverUpdate(InputData, id).then(({ type, message }) => {
      setLoader(false);
      setDriverPopup(false);
      loadLazyData();
      toast?.current?.show({
        severity: type,
        summary: 'Info Message',
        detail: message,
        life: 3000
      });
    });
  };*/
  const dbColumns = useMemo(() => {
    return listViewFields || [];
  }, [listViewFields]);

  const driverDropdownTemplate = (rowData) => {
    if (editingRow === rowData.consignment_id) {
      const driverOptions = (allDriver || []).map((item) => ({
        label: `${item?.drivers?.first_name || ""} ${item?.drivers?.last_name || ""}`,
        value: item?.drivers?.driver_id,
      }));
      return (
        <PrimeDropdown
          value={rowData.driver_id}
          options={driverOptions}
          filter
          filterBy="label"
          showClear
          appendTo={document.body}
          placeholder="Search Driver"
          style={{ width: "180px" }}
          onChange={(e) => {
            handleDriverChange(rowData, e.value);
            setEditingRow(null);
          }}
        />
      );
    }

    return (
      <span
        style={{ cursor: "pointer" }}
        onClick={() => setEditingRow(rowData.consignment_id)}
      >
        {rowData?.driver?.first_name
          ? `${rowData.driver.first_name} ${rowData.driver.last_name}`
          : "Assign"}
      </span>
    );
  };
  const allColumns = useMemo(
    () => [
      {
        field: "job_number",
        header: "Consignment No",
        sortable: true,
        style: { flexGrow: 1, width: "150px" },
      },
      {
        field: "manifest_number",
        header: "Manifest No.",
        body: manifestTemplate,
        sortable: true,
        style: { flexGrow: 1, flexBasis: "150px" },
      },
      {
        field: "customer_id",
        header: "Customer Name",
        body: customerTemplate,
        sortable: true,
        style: { flexGrow: 1, flexBasis: "150px" },
      },
      {
        field: "customer_address",
        header: "Pickup Address",
        body: pickupCustomerTemplate,
        sortable: true,
        style: { flexGrow: 1, flexBasis: "150px" },
      },
      {
        field: "delivery_address",
        header: "Delivery Address",
        body: deliveryCustomerTemplate,
        sortable: true,
        style: { flexGrow: 1, flexBasis: "150px" },
      },
      {
        field: "special_instruction",
        header: "Special Instruction",
        body: specialInstTemplate,
        sortable: true,
        style: { flexGrow: 1, flexBasis: "200px" },
      },
      {
        field: "pallets",
        header: "Pallets",
        body: palletsTemplate,
        sortable: true,
        style: { flexGrow: 1, flexBasis: "130px" },
      },
      {
        field: "spaces",
        header: "Spaces",
        body: spacesTemplate,
        sortable: true,
        style: { flexGrow: 1, flexBasis: "130px" },
      },
      {
        field: "weight",
        header: "Weight(KG)",
        body: weightTemplate,
        sortable: true,
        style: { flexGrow: 1, flexBasis: "130px" },
      },
      {
        field: "no_of_items",
        header: "No. Of Items",
        body: itemsTemplate,
        sortable: true,
        style: { flexGrow: 1, flexBasis: "130px" },
      },
      {
        field: "pickup_date",
        header: "Pickup Date",
        body: pickupDateTemplate,
        sortable: true,
        style: { flexGrow: 1, flexBasis: "130px" },
      },
      {
        field: "delivery_date",
        header: "Delivery Date",
        body: deliveryDateTemplate,
        sortable: true,
        style: { flexGrow: 1, flexBasis: "150px" },
      },
      {
        field: "driver_id",
        header: "Driver Name",
        body: driverDropdownTemplate,
        sortable: true,
        style: { flexGrow: 1, flexBasis: "120px" },
      },
      // { field: "createdAt", header: "Created On", body: createdDateTemplate, sortable: true, style: { flexGrow: 1, flexBasis: "120px" } },
      // { field: "created_by", header: "Created By", body: createdByTemplate, sortable: true, style: { flexGrow: 1, flexBasis: "120px" } },
      {
        field: "status",
        header: "Status",
        body: statusBodyTemplate,
        sortable: true,
        style: { flexGrow: 1, flexBasis: "100px" },
      },
    ],
    [allDriver, editingRow],
  );

  useEffect(() => {
    if (dbColumns?.length > 0) {
      setVisibleColumns(
        allColumns.filter((col) => dbColumns.includes(col.field)),
      );
    } else {
      setVisibleColumns(allColumns);
    }
  }, [dbColumns, allColumns]);
  const handleDefaultView = () => {
    confirmDialog({
      message: "Are you sure you want to set default view.?",
      header: "Confirmation",
      icon: "pi pi-exclamation-triangle",
      accept: () => {
        const updatedFields = editViewFields.map((item) => ({
          ...item,
          selected: true,
        }));
        setEditViewFields(updatedFields);
        saveView(updatedFields);
      },
      reject: () => {
        console.log("Not delete");
      },
    });
  };
  const handleSave = (fieldsData) => {
    confirmDialog({
      message: "Are you sure you want to save the list view changes?",
      header: "Confirmation",
      icon: "pi pi-exclamation-triangle",
      accept: () => {
        saveView(fieldsData);
      },
    });
  };
  const saveView = async (fieldsData) => {
    const dataToSave = fieldsData || editViewFields;

    const selectedFields = dataToSave
      ?.filter((item) => item.selected)
      .map((item) => item.field);

    const postData = {
      view_type: 1,
      user_id: user_id,
      view_list: selectedFields,
    };

    setLoader(true);

    saveListView(postData).then(async ({ type, message }) => {
      setLoader(false);

      await getlistViewData(user_id, 1, "list_view");
      await getlistViewData(user_id, 1, "edit_view");

      setConsignmentViewPopup(false);

      toast?.current?.show({
        severity: type,
        summary: "Info Message",
        detail: message,
        life: 3000,
      });
    });
  };
  const handleDriverChange = async (rowData, driverId) => {
    if (!driverId) {
      setEditingRow(null);
      return;
    }
    confirmDialog({
      message:
        "Are you sure you want to update the driver for this consignment?",
      header: "Confirmation",
      icon: "pi pi-exclamation-triangle",
      accept: async () => {
        try {
          const InputData = {
            driver_id: driverId,
          };
          const { type, message } = await consignmentDriverUpdate(
            InputData,
            rowData.consignment_id,
          );

          toast?.current?.show({
            severity: type,
            summary: "Info Message",
            detail: message,
            life: 3000,
          });

          loadLazyData();
        } catch (error) {
          toast?.current?.show({
            severity: "error",
            summary: "Error",
            detail: "Failed to update driver",
            life: 3000,
          });
        }
      },
      reject: () => {
        console.log("Not update driver");
      },
    });
  };
  return (
    <>
      <Loader show={loader} />
      <Toast ref={toast} position="top-center" />
      <div className="page-wrapper-without-aisde">
        <div className="body-content-wrap overflow-hidden flex-grow-1 bg-white">
          <div className="body-content-top">
            <div className="d-sm-flex align-items-center flex-wrap">
              <div className="d-flex justify-content-between justify-content-sm-start align-items-center flex-grow-1">
                <h2 className="fz24 me-md-3 text-slate-800  me-md-2 fw500 mb-0">
                  <i className="fa-light fa-briefcase"></i>&nbsp; Consignment
                </h2>
              </div>
              <div className="mt-3 mt-sm-0 align-items-center ms-sm-4 ms-md-auto mt-xl-0 d-flex justify-content-end flex-grow-1">
                <Link
                  to="./manifest"
                  className="btn-outline-dark btn fz14 me-3"
                >
                  <i className="fa-light fa-eye"></i> Manifest List
                </Link>
                <Button
                  variant="btn-outline-dark"
                  type="button"
                  onClick={() => {
                    setConsignmentViewPopup(true);
                    getlistViewData(user_id, 1, "edit_view");
                  }}
                  className="btn btn-outline-dark fz14 me-3"
                >
                  <i className="fa-light fa-eye"></i> List View
                </Button>
                <Link
                  to="./add"
                  className={`bg-green text-white btn fz14 me-3 ${consignmentArr.includes("Add") ? "" : "border-0 shadow-none disabled"}`}
                >
                  <i className="fa-light fa-plus-circle"></i> Add New
                  Consignment
                </Link>
                <div className="ms-2">
                  <FilterOffset
                    filterHandle={advanceSearch}
                    offsetFilter={offsetFilter}
                  />
                </div>

                <div className="position-relative flex-grow-1 flex-md-grow-0 me-3">
                  <InputText
                    placeholder="Search"
                    name="globalFilterValue"
                    maxLength={100}
                    onChange={(event) => onGlobalFilterChange1(event)}
                    className="form-control fw500  p-2 pe-5"
                  />
                  <button className="insideSubmitBtn fz14 bg-transparent border-0 position-absolute" onClick={onGlobalFilterChangeOnclick}>
                    <i className="fa-light fa-search"></i>
                  </button>
                </div>

                <Dropdown className="order-4 me-3">
                  <Dropdown.Toggle
                    type="button"
                    className="btn-gradient btn fz14 shadow-none border dropdown-icon-none"
                    variant=""
                  >
                    <i className="fa-light fa-ellipsis"></i>
                  </Dropdown.Toggle>
                  <Dropdown.Menu className="dropdown-menu">
                    <ul>
                      <li>
                        <Button
                          className={`dropdown-item ${consignmentArr.includes("Delete") ? "" : "border-0 shadow-none disabled"}`}
                          to="#"
                          onClick={() => bulkDelete()}
                        >
                          <i className="fa-light me-2 fa-trash"></i>
                          Delete Selected
                        </Button>
                      </li>
                      <li>
                        <Button
                          className="dropdown-item"
                          onClick={() => downloadConsignment("csv")}
                        >
                          <i className="fa-light me-2 fa-file-csv"></i>Download
                          CSV
                        </Button>
                      </li>
                      <li>
                        <Button
                          className="dropdown-item"
                          onClick={() => downloadConsignment("excel")}
                        >
                          <i className="fa-light me-2 fa-file-excel"></i>
                          Download Excel
                        </Button>
                      </li>
                      {/*  <li>
                        <Button className="dropdown-item" onClick={() => bulkActivate()} >
                          <i className="fa-light me-2 fa-check"></i>
                          Active
                        </Button>
                      </li>
                      <li>
                        <Button className="dropdown-item" onClick={() => bulkDeActivate()}>
                          <i className="fa-light me-2 fa-ban"></i>
                          Inactive
                        </Button>
                      </li> */}
                    </ul>
                  </Dropdown.Menu>
                </Dropdown>

                {/*  <Dropdown className="order-4">
                  <Dropdown.Toggle type="button" className="btn-gradient btn fz14 shadow-none border dropdown-icon-none" variant="">
                    <i className="fa-light fa-gear"></i>
                  </Dropdown.Toggle>
                  <Dropdown.Menu className="dropdown-menu">
                    <div className="form-group px-2 border-bottom pb-2">
                      <div className="position-relative">
                        <input type="text" className="form-control fw600 rounded p-2" placeholder="Search" />
                        <button className="insideSubmitBtn fz14 bg-transparent border-0 position-absolute"><i className="fa-light fa-search"></i></button>
                      </div>
                    </div>
                    <ul className="max-height-300 filterTable">
                      <li><label className="dropdown-item align-items-center d-flex py-2"> <input type="checkbox" checked="" data-val="job-type" className="me-2" /> Job Type</label></li>
                      <li><label className="dropdown-item align-items-center d-flex py-2"> <input type="checkbox" checked="" data-val="pickup-address" className="me-2" /> Pickup Address</label></li>
                      <li><label className="dropdown-item align-items-center d-flex py-2"> <input type="checkbox" checked="" data-val="delivery-address" className="me-2" /> Delivery Address</label></li>
                      <li><label className="dropdown-item align-items-center d-flex py-2"> <input type="checkbox" checked="" data-val="driver-name" className="me-2" /> Driver Name</label></li>
                    </ul>
                  </Dropdown.Menu>
                </Dropdown> */}
              </div>
            </div>
          </div>
          <div className="table-wrapper flex-grow-1">
            <DataTable
              value={list}
              lazy
              selectionMode="checkbox"
              dataKey="job_number"
              {...{ scrollHeight: tableHeight }}
              scrollDirection="both"
              paginator
              rows={REACT_APP_TABLE_ROWS ?? 50}
              totalRecords={totalRecords}
              onPage={onPage}
              first={lazyParams.first}
              onSort={onSort}
              sortField={lazyParams.sortField}
              sortOrder={lazyParams.sortOrder}
              onFilter={onFilter}
              filters={lazyParams.filters}
              loading={loading}
              selection={selectedCustomers}
              onSelectionChange={(e) => setSelectedCustomers(e.value)}
              {...dataTableConfig}
            >
              <Column
                headerStyle={{ width: "3em" }}
                selectionMode="multiple"
                frozen
              ></Column>
              <Column
                field="action"
                header="Action"
                body={actionBodyTemplate}
                exportable={false}
                style={{ minWidth: "11rem" }}
                frozen
              ></Column>
              {visibleColumns.map((col) => (
                <Column
                  key={col.field}
                  field={col.field}
                  header={col.header}
                  body={col.body}
                  sortable={col.sortable}
                  style={col.style}
                />
              ))}

              {/* <Column field="job_number" header="Job Number" sortable style={{ flexGrow: 1, width: "220px" }}></Column>
              <Column field="manifest_number" header="Manifesto No." body={manifestTemplate} sortable style={{ flexGrow: 1, flexBasis: "150px" }}></Column>
              <Column field="customer_id" body={customerTemplate} header="Customer Name" sortable style={{ flexGrow: 1, flexBasis: "200px" }}></Column>
              <Column field="customer_address" header="Pickup Address" body={pickupCustomerTemplate} sortable style={{ flexGrow: 1, flexBasis: "200px" }}></Column>
              <Column field="delivery_address" header="Delivery Address" body={deliveryCustomerTemplate} sortable style={{ flexGrow: 1, flexBasis: "200px" }}></Column>
              <Column field="pickup_date" body={pickupDateTemplate} header="Pickup Date" sortable style={{ flexGrow: 1, flexBasis: "130px" }}></Column>
              <Column field="delivery_date" body={deliveryDateTemplate} header="Delivery Date" sortable style={{ flexGrow: 1, flexBasis: "150px" }}></Column>
              <Column field="driver_id" body={driverNameTemplate} header="Driver Name" sortable style={{ flexGrow: 1, flexBasis: "150px" }}></Column>
              <Column field="createdAt" header="Created On" body={createdDateTemplate} sortable style={{ flexGrow: 1, flexBasis: "120px" }}></Column>
              <Column field="created_by" header="Created By" body={createdByTemplate} sortable style={{ flexGrow: 1, flexBasis: "120px" }}></Column>
              <Column field="status" header="Status" body={statusBodyTemplate} sortable style={{ flexGrow: 1, flexBasis: "100px" }}></Column>*/}
            </DataTable>
            {/*<Dialog
              header="Update Driver"
              visible={driverPopup}
              style={{ width: '450px' }}
              modal
              onHide={() => setDriverPopup(false)}
            >
              <div className="mb-3">
                <label className="mb-2 d-block">
                  Job Number
                </label>

                <InputText
                  value={selectedConsignment?.job_number || ''}
                  disabled
                  className="w-100"
                />
              </div>

              <div className="mb-3">
                <label className="mb-2 d-block">
                  Select Driver
                </label>

                <PrimeDropdown
                value={selectedDriver}
                options={(allDriver || []).map(item => ({
                  label: `${item?.drivers?.first_name || ''} ${item?.drivers?.last_name || ''}`,
                  value: item?.drivers?.driver_id
                }))}
                className="driver_update_popup"
                placeholder="Select Driver"
                onChange={(e) => setSelectedDriver(e.value)}
                style={{ width: '100%' }}
                filter
              />
              {driverError && (
                <small className="from-error-span">
                  {driverError}
                </small>
              )}
              </div>

              <div className="text-end">                
                <Button type="submit" onClick={updateDriver} variant="" className="bg-green text-white btn fz14 "><i className="fa-regular fa-save"></i> Save</Button>
              </div>
            </Dialog>*/}
            <Dialog
              header="List View"
              visible={consignmentViewPopup}
              style={{ width: "500px" }}
              modal
              onHide={() => setConsignmentViewPopup(false)}
            >
              <div className="row">
                {editViewFields?.map((item, index) => (
                  <div className="col-md-6 mb-3" key={index}>
                    <div className="d-flex align-items-center gap-2">
                      <input
                        type="checkbox"
                        id={item.field}
                        checked={item.selected}
                        onChange={() => handleCheckboxChange(item.field)}
                      />

                      <label htmlFor={item.field} className="mb-0">
                        {item.label}
                      </label>
                    </div>
                  </div>
                ))}
              </div>
              <div className="text-end mt-3">
                <Button
                  variant=""
                  className="btn-outline-dark btn fz14 me-2"
                  onClick={handleDefaultView}
                >
                  Default View
                </Button>
                <Link
                  to="#"
                  onClick={(e) => {
                    e.preventDefault();
                    setConsignmentViewPopup(false);
                  }}
                  className="btn-gradient btn fz14 me-3"
                >
                  <i className="fa-light fa-times"></i> Cancel
                </Link>
                <Button
                  variant=""
                  onClick={() => handleSave(editViewFields)}
                  className="bg-green text-white btn fz14"
                >
                  <i className="fa-regular fa-save"></i> Save
                </Button>
              </div>
            </Dialog>
            <Dialog
              header="Special Instruction"
              visible={specialInstructionPopup}
              style={{ width: "600px", maxWidth: "95vw" }}
              modal
              onHide={() => {
                setSpecialInstructionPopup(false);
                setSelectedSpecialInstruction("");
              }}
            >
              <div
                style={{
                  whiteSpace: "pre-wrap",
                  overflowWrap: "anywhere",
                  maxHeight: "60vh",
                  overflowY: "auto",
                }}
              >
                {selectedSpecialInstruction}
              </div>
            </Dialog>
            <Dialog
              header="Job Details"
              visible={itemsPopup}
              style={{ width: "1200px" }}
              modal
              onHide={() => {
                setItemsPopup(false);
                setSelectedItems([]);
              }}
            >
              {selectedItems?.length > 0 ? (
                <div className="table-responsive">
                  <table className="table table-bordered mb-0" style={{ minWidth: "1000px" }}>
                    <thead>
                      <tr>
                        <th style={{ width: "30px" }}>#</th>
                        <th style={{ width: "100px" }}>No of Items</th>
                        <th style={{ width: "250px" }}>Freight Description</th>
                        <th style={{ width: "100px" }}>Pallets</th>
                        <th style={{ width: "100px" }}>Spaces</th>
                        <th style={{ width: "100px" }}>Weight (KG)</th>
                        <th style={{ width: "200px" }}>Job Temp</th>
                        <th style={{ width: "150px" }}>Receivers Ref</th>
                        <th style={{ width: "150px" }}>Senders Ref</th>  
                      </tr>
                    </thead>

                    <tbody>
                      {selectedItems.map((item, index) => (
                        <tr key={index}>
                          <td>{index + 1}</td>
                          <td>{item?.no_of_items || "-"}</td>
                          <td>{item?.freight_desc || "-"}</td>
                          <td>{item?.pallets || "-"}</td>
                          <td>{item?.spaces || "-"}</td>
                          <td>{item?.weight || "-"}</td>                          
                          <td>{item?.job_temp || "-"}</td>
                          <td>{item?.recipient_no || "-"}</td>
                          <td>{item?.senders_no || "-"}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              ) : (
                <div className="text-center py-3">No items found</div>
              )}
            </Dialog>
          </div>
        </div>
      </div>
    </>
  );
}

export default List;
